import styled from '@emotion/styled';

const Wrapper = styled.div(
  {
    padding: '9px 20px 14px 25px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '7px',
    borderWidth: '1.5px',
    borderStyle: 'solid',
    lineHeight: 1.3
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.colors.white,
    borderColor: theme.palette.colors.columbiaBlue
  })
);

export default Wrapper;
